import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CopyAndPasteModule } from '@shared-modules/copy-and-paste/copy-and-paste.module';
import { DocumentVerificationService } from './components/rapi-doc-info/document-verification.service';
import { RapiDocInfoComponent } from './components/rapi-doc-info/rapi-doc-info.component';
import { EmailVerificationService } from './components/rapi-email/email-verification.service';
import { RapiEmailComponent } from './components/rapi-email/rapi-email.component';
import { RapiLoaderComponent } from './components/rapi-loader/rapi-loader.component';
import { RapiPasswordComponent } from './components/rapi-password/rapi-password.component';
import { RapiPersoReferenceComponent } from './components/rapi-perso-reference/rapi-perso-reference.component';
import { PhoneVerificationService } from './components/rapi-phone/phone-verification.service';
import { RapiPhoneComponent } from './components/rapi-phone/rapi-phone.component';
import { RapiRadioGroupComponent } from './components/rapi-radio-group/rapi-radio-group.component';
import { RapiSelectComponent } from './components/rapi-select/rapi-select.component';
import { RapiCurrencyInputComponent } from './components/rapi-currency-input/rapi-currency-input.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { FormlyModule } from '@ngx-formly/core';

// Auth SSO Feature
import { SsoModule } from '@auth/sso/sso/sso.module';

@NgModule({
  declarations: [
    RapiDocInfoComponent,
    RapiEmailComponent,
    RapiPasswordComponent,
    RapiPersoReferenceComponent,
    RapiPhoneComponent,
    RapiRadioGroupComponent,
    RapiSelectComponent,
    RapiLoaderComponent,
    RapiCurrencyInputComponent,
  ],
  imports: [
    SsoModule,
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule,
    CopyAndPasteModule,
    NgxCurrencyModule,
    FormlyModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    RapiDocInfoComponent,
    RapiEmailComponent,
    RapiPasswordComponent,
    RapiPersoReferenceComponent,
    RapiPhoneComponent,
    RapiRadioGroupComponent,
    RapiSelectComponent,
    ReactiveFormsModule,
    RapiLoaderComponent,
  ],
  providers: [DocumentVerificationService, EmailVerificationService, PhoneVerificationService],
})
export class CoreModule {}
